/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import CampaignModel, { CampaignState } from 'cio/models/campaign';

interface CampaignsTriggerSetupDateNextPeopleArgs {
  campaign: CampaignModel;
  people: any;
  isLoading: boolean;
  fetchNextPeople: (page: number) => unknown;
}

export default class CampaignsTriggerSetupDateNextPeople extends Component<CampaignsTriggerSetupDateNextPeopleArgs> {
  @tracked page = 0;

  @action
  didInsert() {
    if (this.args.campaign.isRunning) {
      this.args.fetchNextPeople(this.page);
    }
  }

  get noNextPeopleDueToCampaignStateText() {
    let adjStateMap: Record<string, string> = {
      [CampaignState.Archiving]: 'archiving',
      [CampaignState.Archived]: 'archived',
      [CampaignState.Stopped]: 'stopped',
      [CampaignState.Stopping]: 'stopped', // sic - transition state to "stopped"
      [CampaignState.Sunsetting]: 'stopped', // sic - it doesn't accept matches, so same as "stopped" for purposes of "next people" component
    };

    let adj = adjStateMap[this.args.campaign.state];

    return adj && `This campaign is ${adj}.`;
  }
}
